import React, { useContext, useEffect, useState } from 'react';
import { Col, Menu, Row } from 'antd';
import { NavLink, Route, Switch, useLocation } from 'react-router-dom';
import { UsersPage } from './users';
import { RolePage, RolesPage } from './roles';
import {
  ApartmentOutlined,
  BarsOutlined,
  BlockOutlined,
  BorderlessTableOutlined,
  SafetyOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { UserContext } from '../contexts';
import {
  hasAdminRolesPageRole,
  hasAdminUsersPageRole,
  hasAdminAreasPageRole,
  hasAdminSystemSettingsPageRole,
  hasAdminRiskPrioritiesPageRole,
  hasAdminRiskCategoriesPageRole,
  hasAdminLocationsPageRole,
} from '../../utils';
import { LocationsPage } from './locations';
import { AreasPage } from './areas';
import { SystemSettingsPage } from './system-settings';
import { RiskPrioritiesPage } from './risk-priorities';
import { RiskCategoriesPage } from './risk-categories';

export function AdminPage() {
  const { pathname } = useLocation();
  const [path, setPath] = useState('');
  const { user } = useContext(UserContext);

  useEffect(() => {
    let path = '/admin';
    if (pathname === path) {
      path += '/users';
    } else {
      path += '/' + pathname.split('/')[2];
    }
    setPath(path);
  }, [pathname]);

  const links = [] as any[];
  if (hasAdminUsersPageRole(user)) {
    links.push({
      path: '/admin/users',
      text: 'Kullanıcılar',
      icon: <UserOutlined />,
    });
  }
  if (hasAdminRolesPageRole(user)) {
    links.push({
      path: '/admin/roles',
      text: 'Roller',
      icon: <SafetyOutlined />,
    });
  }
  if (hasAdminLocationsPageRole(user)) {
    links.push({
      path: '/admin/locations',
      text: 'Lokasyonlar',
      icon: <ApartmentOutlined />,
    });
  }
  if (hasAdminAreasPageRole(user)) {
    links.push({
      path: '/admin/areas',
      text: 'Alanlar',
      icon: <BlockOutlined />,
    });
  }
  if (hasAdminRiskPrioritiesPageRole(user)) {
    links.push({
      path: '/admin/risk-priorities',
      text: 'Risk öncelikleri',
      icon: <BorderlessTableOutlined />,
    });
  }
  if (hasAdminRiskCategoriesPageRole(user)) {
    links.push({
      path: '/admin/risk-categories',
      text: 'Risk kategorileri',
      icon: <BarsOutlined />,
    });
  }

  if (hasAdminSystemSettingsPageRole(user)) {
    links.push({
      path: '/admin/system-settings',
      text: 'Sistem ayarları',
      icon: <ToolOutlined />,
    });
  }

  return (
    <Row>
      <Col span={6} xs={24} sm={24} md={6} lg={6} xl={5} xxl={4}>
        <Menu mode="inline">
          <Menu.ItemGroup title="Yönetim" />
        </Menu>
        <Menu mode="inline" selectedKeys={[path]} openKeys={['/admin/ewo-settings']} style={{ paddingBottom: '3rem' }}>
          {links.map(l => (
            <>
              {!l.children?.length ? (
                <Menu.Item key={l.path} icon={l.icon}>
                  <NavLink to={l.path}>{l.text}</NavLink>
                </Menu.Item>
              ) : (
                <Menu.SubMenu key={l.path} title={l.text} icon={l.icon}>
                  {l.children.map((sl: any) => (
                    <Menu.Item key={sl.path}>
                      <NavLink to={sl.path}>{sl.text}</NavLink>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              )}
            </>
          ))}
        </Menu>
      </Col>
      <Col span={18} xs={24} sm={24} md={18} lg={18} xl={19} xxl={20}>
        <Switch>
          <Route exact path="/admin" component={UsersPage} />
          <Route exact path="/admin/users" component={UsersPage} />
          <Route exact path="/admin/roles" component={RolesPage} />
          <Route exact path="/admin/roles/:id" component={RolePage} />
          <Route exact path="/admin/locations" component={LocationsPage} />
          <Route exact path="/admin/areas" component={AreasPage} />
          <Route exact path="/admin/risk-priorities" component={RiskPrioritiesPage} />
          <Route exact path="/admin/risk-categories" component={RiskCategoriesPage} />
          <Route exact path="/admin/system-settings" component={SystemSettingsPage} />
        </Switch>
      </Col>
    </Row>
  );
}
